// extracted by mini-css-extract-plugin
export var brand = "_a2-9";
export var compact = "_a2-6";
export var extraSmall = "_a2-7";
export var icon = "_a2-0";
export var large = "_a2-4";
export var light = "_a2-1";
export var medium = "_a2-5";
export var outline = "_a2-b";
export var primaryDark = "_a2-a";
export var primaryLight = "_a2-8";
export var primaryModern = "_a2-c";
export var success = "_a2-2";
export var successSolid = "_a2-3";